// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-2769a492]{display:none}.modal .modal-subtitle[data-v-2769a492]{color:var(--c-black-secondary);font-size:16px;font-weight:600;line-height:16px;margin-top:6px}.form__element[data-v-2769a492]{margin:0 0 var(--spacer-xl) 0}.error[data-v-2769a492]{color:var(--_c-red-primary)}[data-v-2769a492] .base-loader.loader{min-height:40px}[data-v-2769a492] .base-loader.loader .base-loader__overlay{background-color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
